import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Dashboard from "./screens/Dashboard/Dashboard";
import LoginScreen from "./screens/LoginScreen/LoginScreen";

const App = () => {

  let isLogin = true;
  let navigate = useNavigate();

  if (window.window.localStorage.getItem("UserToken") === null || window.window.localStorage.getItem("UserToken") === undefined
    || window.window.localStorage.getItem("UserToken") === "") {
    isLogin = false;
  }

  useEffect(() => {


    if (isLogin === true) {
      if (!document.URL.includes("/dashboard/") && !document.URL.includes("/dashboard/logout")) {
        navigate("/dashboard/home");
      }
    }
    else {
      if (document.URL.includes("/dashboard/")) {
        navigate("/");
      }
    }

    return;
  }, [isLogin, navigate]);



  if (isLogin === false) {
    return (<LoginScreen />);
  }

  return (<Dashboard />);

};

export default App;